import { Alert } from 'antd';
import { capitalize } from 'lodash';
const MessageBox = ({
  message,
  type = 'info',
  title = capitalize(type)
}) => <Alert message={title} description={message} type={type} showIcon data-sentry-element="Alert" data-sentry-component="MessageBox" data-sentry-source-file="MessageBox.jsx" />;
export default MessageBox;